export class CollaboratorCard {
  profileImg: string;
  name: string;
  brandName: string;
  brandImg: string;


  constructor(profileImg: string, name: string, brandName: string, brandImg: string) {
    this.profileImg = profileImg;
    this.name = name;
    this.brandName = brandName;
    this.brandImg = brandImg;
  }
}
